/**
 * 文件列表排序：失败置顶，进行中次之，其余按加入时间。
 */

export function isFailedRow(row) {
  return (
    row.validateStatus === 'failed' ||
    row.cloudStatus === 'failed' ||
    row.saveStatus === 'failed'
  )
}

function isActiveCloudRow(row) {
  return row.cloudStatus === 'uploading' || row.cloudStatus === 'queued'
}

export function sortFileList(fileList) {
  return [...fileList].sort((a, b) => {
    const aFailed = isFailedRow(a)
    const bFailed = isFailedRow(b)
    if (aFailed !== bFailed) return aFailed ? -1 : 1

    const aActive = isActiveCloudRow(a)
    const bActive = isActiveCloudRow(b)
    if (aActive !== bActive) return aActive ? -1 : 1

    const aTime = a.uploadedAt || a.addedAt || 0
    const bTime = b.uploadedAt || b.addedAt || 0
    if (aTime !== bTime) return aTime - bTime

    return (a.name || '').localeCompare(b.name || '')
  })
}
